import { Select } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { usePersons } from "../../../../hooks/usePersons";
import { isNotChangeable, type TodoTableTodo } from "../TodoTable";

function getPersonColumn(
  allPersons: Array<string>,
  handleChangePerson: (todoId: number, newPersonId: number | null) => void
): MRT_ColumnDef<TodoTableTodo> {
  return {
    header: "Verpflichtetes Unternehmen",
    accessorKey: "person",
    size: 220,
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: ["(leer)", ...allPersons.sort((a, b) => a.localeCompare(b))]
    },
    filterFn: (row, id, filterValues) => {
      if (filterValues.length === 0) {
        return true;
      }
      if (filterValues.includes("(leer)") && row.getValue(id) === null) {
        return true;
      }
      return filterValues.includes(row.getValue(id));
    },
    Cell: ({ row }) => {
      const {
        persons,
        isLoading: personsLoading,
        error: personsError
      } = usePersons({ variantId: row.original.variant });

      return personsLoading || personsError || isNotChangeable(row.original) ? (
        row.original.person
      ) : (
        <Select
          data={[
            { value: "", label: "---" },
            ...persons.map((p) => ({
              value: p.id.toString(),
              label: p.name
            }))
          ]}
          value={persons
            .find((p) => p.name === row.original.person)
            ?.id.toString()}
          onChange={(newPersonId) =>
            handleChangePerson(
              row.original.id,
              newPersonId === null || newPersonId === ""
                ? null
                : parseInt(newPersonId, 10)
            )
          }
        />
      );
    }
  };
}

export { getPersonColumn };
